/* The Miles We Get — small, dependency-free interactions */
(() => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('#tmwg-mobile-menu');
  if (menuButton && mobileMenu) {
    const close = () => { mobileMenu.hidden = true; menuButton.setAttribute('aria-expanded', 'false'); menuButton.setAttribute('aria-label','Open navigation'); };
    menuButton.addEventListener('click', () => {
      const open = mobileMenu.hidden;
      mobileMenu.hidden = !open;
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    document.addEventListener('click', e => { if (!mobileMenu.hidden && !e.target.closest('[data-header]')) close(); });
  }
  document.querySelectorAll('[data-qty-decrease],[data-qty-increase]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      input.value = Math.max(1, (Number(input.value) || 1) + (button.matches('[data-qty-increase]') ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    const section = productForm.closest('.tmwg-product');
    const dataTag = section.querySelector('[data-product-variants]');
    let variants = [];
    try { variants = JSON.parse(dataTag?.textContent || '[]'); } catch (_) { variants = []; }
    const optionSelects = [...productForm.querySelectorAll('[data-product-option]')];
    const variantInput = productForm.querySelector('[data-variant-id]');
    const addButton = productForm.querySelector('[data-add-to-cart]');
    const addLabel = productForm.querySelector('[data-add-label]');
    const priceEl = section.querySelector('[data-product-price]');
    const compareEl = section.querySelector('[data-compare-price]');
    const currency = section.dataset.currency || 'USD';
    const fmt = cents => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
      catch (_) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
    };
    function selectVariant() {
      if (!optionSelects.length || !variants.length) return;
      const selected = optionSelects.map(o => o.value);
      const variant = variants.find(v => selected.every((value,i) => (v.options || [v.option1,v.option2,v.option3])[i] === value));
      if (!variant) { addButton.disabled = true; addLabel.textContent = 'UNAVAILABLE'; return; }
      variantInput.value = variant.id;
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'ADD TO THE BAG' : 'SOLD OUT';
      if (priceEl) priceEl.textContent = fmt(variant.price);
      if (compareEl) { compareEl.hidden = !(variant.compare_at_price > variant.price); compareEl.textContent = compareEl.hidden ? '' : fmt(variant.compare_at_price); }
      try { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url.toString()); } catch (_) {}
    }
    optionSelects.forEach(o => o.addEventListener('change', selectVariant));
  }
  document.documentElement.classList.remove('no-js');
})();
